'use es6';

import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap, fromJS } from 'immutable';
import { SUBMISSION_TAG_TYPE_ID } from '../constants/ObjectTypeIds';
import { formatSubmissionTags } from '../formatters/formatSubmissionTags';
const CRM_SEARCH_URL = 'crm-search/search';
const PAGE_SIZE = 10;
const getSubmissionTagOptions = ({
  offset = 0,
  nameSearch = null,
  count = PAGE_SIZE
}) => {
  return {
    count,
    offset,
    objectTypeId: SUBMISSION_TAG_TYPE_ID,
    requestOptions: {
      properties: ['hs_object_id', 'hs_tag_name']
    },
    query: nameSearch
  };
};
export const createFetchByIds = ({
  httpClient
}) => ids => httpClient.post(CRM_SEARCH_URL, {
  data: Object.assign({}, getSubmissionTagOptions({
    count: PAGE_SIZE,
    offset: 0,
    nameSearch: ''
  }), {
    filterGroups: [{
      filters: [{
        operator: 'IN',
        property: 'hs_object_id',
        values: ids
      }]
    }]
  })
}).then(fromJS).then(res => formatSubmissionTags(res).get('results'));
export const fetchByIds = createFetchByIds({
  httpClient: http
});
export const createSearchSubmissionTags = ({
  httpClient
}) => (args = ImmutableMap({
  offset: 0,
  query: '',
  count: PAGE_SIZE
})) => {
  const {
    offset,
    count,
    query
  } = args.toJS();
  return httpClient.post(CRM_SEARCH_URL, {
    data: getSubmissionTagOptions({
      count,
      offset,
      nameSearch: query
    })
  }).then(fromJS).then(formatSubmissionTags);
};
export const searchSubmissionTag = createSearchSubmissionTags({
  httpClient: http
});